import React from "react";
import {
  COACHING_DOMAIN,
  CoachingFaq,
  coachingFaqApi,
  FAQ_LIST_ENDPOINT,
} from "api/coachingFaqApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import ButtonWithModal from "../../common/ButtonWithModal";
import Link from "../../common/Link";

interface DeleteCoachingFaqButtonProps {
  faq: CoachingFaq;
}

export default function DeleteCoachingFaqButton({
  faq,
}: DeleteCoachingFaqButtonProps) {
  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: () => coachingFaqApi.delete(faq.faqId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [COACHING_DOMAIN, FAQ_LIST_ENDPOINT],
      });
    },
  });

  return (
    <>
      <ButtonWithModal
        buttonText=""
        size="lg"
        title={"이 FAQ를 삭제할까요?"}
        content={`${faq.question}`}
        actionButtonColor={"danger"}
        actionText="삭제하기"
        cancelText="취소"
        action={() => deleteMutation.mutate()}
        render={<Link text="삭제" opacity={1} textColor="primary.solid" />}
      />
    </>
  );
}